'use strict';

module.exports = 'enhanceArray';


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/enumerable/var/ARRAY_ENHANCEMENTS_FLAG.js
// module id = 81
// module chunks = 1